export type ExternalPageSize = number | 'all';
export type PageSizeMode = 'all' | null;

export const allResultsPageSize = 10000;

export type PaginationState = {
  pageSize: number;
  pageSizeMode: PageSizeMode;
};

function isValidNumericPageSize(value: unknown): value is number {
  return typeof value === 'number' && Number.isInteger(value) && value >= 0;
}

function normalizeFallbackPageSize(pageSize: unknown): number {
  return isValidNumericPageSize(pageSize) ? pageSize : allResultsPageSize;
}

export function normalizePageSize(
  pageSize: unknown,
  fallbackPageSize: unknown = allResultsPageSize,
): PaginationState {
  const fallback =
    fallbackPageSize === 'all' ? allResultsPageSize : normalizeFallbackPageSize(fallbackPageSize);

  if (pageSize === 'all') {
    return { pageSize: allResultsPageSize, pageSizeMode: 'all' };
  }

  return {
    pageSize: isValidNumericPageSize(pageSize) ? pageSize : fallback,
    pageSizeMode: null,
  };
}

export function serializePageSize(
  pageSize: ExternalPageSize | undefined,
  pageSizeMode: PageSizeMode | undefined,
): ExternalPageSize | undefined {
  return pageSize === 'all' || pageSizeMode === 'all' ? 'all' : pageSize;
}

export function normalizeRequestPageSize<
  TRequest extends { pageSize?: unknown; pageSizeMode?: PageSizeMode },
>(
  request: TRequest,
  fallbackPageSize?: unknown,
): Omit<TRequest, 'pageSize' | 'pageSizeMode'> & PaginationState {
  return {
    ...request,
    ...normalizePageSize(request.pageSize, fallbackPageSize),
  };
}
